<template>
  <v-checkbox
    class="layer-list-item"
    color="primary"
    hide-details
    :name="layer.id"
    :disabled="disabled"
    :readonly="readonly"
    :value="layer.id"
    :input-value="value"
    @change="updateValue"
    :ref="`layer-${layer.id}`"
  >
    <template v-slot:label>
      <div class="layer-list-item__label">
        <slot name="label-prepend"></slot>
        <div class="mr-2 flex-grow-1">
          <span>{{ layer.name }}</span>
          <v-chip class="layer-list-item__chip ml-2" v-if="layer.isNew" color="#faf3e8" text-color="#f5a623" small>
            New
          </v-chip>
        </div>
        <template v-if="cheapValue === 'featureCount'">
          <v-tooltip v-if="layer.featureCount" top>
            <template v-slot:activator="{ on }">
              <v-chip
                class="layer-list-item__chip cursor-pointer font-weight-medium"
                color="secondary"
                text-color="primary"
                small
                v-on="on"
              >
                {{ numberWithSpaces(layer.featureCount) }}
              </v-chip>
            </template>
            <span v-html="$t('product.objectsInLayer')"></span>
          </v-tooltip>
        </template>
        <v-chip v-else class="layer-list-item__chip" color="secondary" text-color="primary" small>
          {{ layer[cheapValue] }}
        </v-chip>
        <slot name="label-append"></slot>
      </div>
    </template>
  </v-checkbox>
</template>

<script>
import { numberWithSpaces } from '@/utils/utils';

export default {
  name: 'LayerListItem',
  props: {
    layer: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      required: true,
    },
    cheapValue: {
      type: String,
      default: 'type',
    },
  },
  methods: {
    numberWithSpaces,
    updateValue(newValue) {
      this.$emit('input', newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.layer-list-item {
  width: 100%;
  margin-top: 4px;
  padding: 4px 2px 4px 6px;

  .v-input__control {
    width: 100%;
    margin-left: -2px;
  }

  .v-input__slot {
    align-items: flex-start;
  }

  .v-label {
    width: 100%;
    padding-top: 4px;
    padding-bottom: 4px;
    margin-top: -4px;
    margin-bottom: -4px;
  }

  &:hover {
    background-color: #f6f8fa;
  }

  &::v-deep .v-input--selection-controls.v-input--is-disabled:not(.v-input--indeterminate) .v-icon {
    color: $gray-dark;
  }
}

.layer-list-item__label {
  display: flex;
  width: 100%;
  align-items: center;
  font-size: 14px;
  color: #212121;
}

.layer-list-item__chip {
  border: 0 !important;
  transition: none !important;
  vertical-align: top;
  font-size: 14px;
  overflow: visible;

  .v-chip__content {
    cursor: inherit;
  }
}
</style>
